import script from "./pwd_reissue.vue?vue&type=script&setup=true&lang=ts"
export * from "./pwd_reissue.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__